import {Component, input} from '@angular/core';

@Component({
  selector: 'app-accent',
  imports: [],
  templateUrl: './accent.component.html',
  styleUrls: ['./accent.component.scss'],
})
export class AccentComponent {
  public title = input<string>();
}
